/* global MicroModal */

class TransactionsModal {
  constructor(element) {
    this.description = '';
    this.date = '';
    this.linkUrl = '';
    this.linkText = '';
    this.newWindow = '';
    this.list = element.querySelector('[data-ref="transactions-list"]');
    this.gridItems = this.list.querySelectorAll('[data-ref="transaction-grid-item"]');
    this.trigger = '[data-ref="transaction-item"]';
    this.header = element.querySelector('[data-ref="transaction-header"]');
    this.modalId = 'transaction-modal';

    this.bindFunctions();
    this.bindEvents();
    this.renderModalTemplate();
  }

  bindFunctions() {
    this.onTriggerHover = this.onTriggerHover.bind(this);
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onFilterClick = this.onFilterClick.bind(this);
  }

  bindEvents() {
    this.list.addEventListener('mouseover', this.onTriggerHover);
    this.list.addEventListener('click', this.onTriggerClick);
    this.header.addEventListener('click', this.onFilterClick);
  }

  onFilterClick(event) {
    // check if button was clicked
    const $button = event.target.closest('.transaction-filter-button');
    if (!$button) return;

    const isSelected = $button === this.$selectedFilterButton;
    if (isSelected) {
      // already selected, revert to show all
      this.$selectedFilterButton.classList.remove('is-selected');
      this.$selectedFilterButton = undefined;
      this.gridItems.forEach(($item) => {
        $item.style.display = '';
      });
      return;
    }

    const category = $button.getAttribute('data-filter-category');

    if (category == 'view-all') {
      this.gridItems.forEach(($item) => {
        $item.style.display = '';
      });
    } else {
    // // filter items if categories match
      this.gridItems.forEach(($item) => {
        const itemCategory = $item.getAttribute('data-category');
        $item.style.display = itemCategory === category ? '' : 'none';
      });
    }

    // change selected filter button
    if (this.$selectedFilterButton) this.$selectedFilterButton.classList.remove('is-selected');
    this.$selectedFilterButton = $button;
    this.$selectedFilterButton.classList.add('is-selected');
  }

  /**
   * Render template and place at end of body
   */
  renderModalTemplate() {
    const template = `<div class="modal modal--slide" id="${this.modalId}" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="team-member-title">
                <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>

                <div class="modal__content" id="transaction-content"></div>
            </div>
        </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', template);

    // Save reference for scroll positioning later
    this.modal = document.getElementById(this.modalId);
    this.overlay = this.modal.querySelector('.modal__overlay');
    this.modalContent = document.getElementById('transaction-content');
  }

  onTriggerHover(event) {
    // If the event target doesn't match bail
    if (!event.target.closest(this.trigger)) return;

    this.loadData(event.target.closest(this.trigger));
  }

  onTriggerClick(event) {
    // If the event target doesn't match bail
    if (!event.target.closest(this.trigger)) return;
    event.preventDefault();
    this.showModal();
  }

  loadData(element) {
    this.description = element.dataset.description;
    this.date = element.dataset.date;
    this.linkUrl = element.dataset.linkUrl;
    this.linkText = element.dataset.linkText;
    this.newWindow = element.dataset.newWindow;

    this.render();
  }

  unloadData() {
    this.description = '';
    this.date = '';
    this.linkUrl = '';
    this.linkText = '';
    this.newWindow = '';
  }

  showModal() {
    MicroModal.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      onClose: () => {
        this.unloadData();
      },
      onShow: () => {
        this.overlay.scrollTop = 0;
      },
    });
  }

  render() {
    let template = '<div class="modal__text modal__text--transactions">';

    if (this.date) {
      template += `<p class="type-eyebrow mb-space-fixed-2">${this.date}</p>`;
    }

    if (this.description) {
      template += `<div class="text stack-s type-body mb-space-fixed-2">${this.description}</div>`;
    }


    if (this.linkText && this.linkUrl) {
      template += `<a class="btn" href="${this.linkUrl}"`;

      if (this.newWindow) {
        template += ' target="_blank" rel="noopener noreferrer"';
      }

      template+= `>${this.linkText}</a>`;
    }

    template += '</div>';

    this.modalContent.innerHTML = template;
  }
}

const transactionsList = document.querySelectorAll('[data-ref="transactions"]');

if (transactionsList && transactionsList.length > 0) {
  transactionsList.forEach((list) => {
    new TransactionsModal(list);
  });
}
